import { parseJourney, type CoachJourney, type CoachJourneyInput } from '../schema';
import { contentStudioJourney as contentStudioInput } from './contentStudio';
import { boardStarterJourney as boardStarterInput } from './boardStarter';
import { scriptShootPostJourney as scriptShootPostInput } from './scriptShootPost';
import { wbbcPostJourney as wbbcPostInput } from './wbbcPost';
import { wbbcCopilotJourney as wbbcCopilotInput } from './wbbcCopilot';
import { copilotJourney as copilotInput } from './copilot';
import { welcomeJourney as welcomeInput } from './welcome';
import { firstPostJourney as firstPostInput } from './firstPost';
import { brandDnaJourney as brandDnaInput } from './brandDna';

/** Journeys that ship with the app, as written. `journeys.test.ts` proves every one is valid. */
export const COACH_JOURNEY_INPUTS: readonly CoachJourneyInput[] = [
  welcomeInput,
  contentStudioInput,
  scriptShootPostInput,
  boardStarterInput,
  wbbcPostInput,
  wbbcCopilotInput,
  copilotInput,
  firstPostInput,
  brandDnaInput,
];

/**
 * The valid ones, parsed. A journey that fails validation is left out with a console error
 * instead of throwing, so a bad journey can never break the product code that imports this.
 */
export const COACH_JOURNEYS: readonly CoachJourney[] = COACH_JOURNEY_INPUTS.flatMap(input => {
  const parsed = parseJourney(input);
  if (parsed.ok) return [parsed.journey];
  console.error(parsed.error);
  return [];
});

export const SCRIPT_SHOOT_POST_JOURNEY_ID = scriptShootPostInput.id;
export const BOARD_STARTER_JOURNEY_ID = boardStarterInput.id;
export const WBBC_POST_JOURNEY_ID = wbbcPostInput.id;
export const WBBC_COPILOT_JOURNEY_ID = wbbcCopilotInput.id;
export const COPILOT_JOURNEY_ID = copilotInput.id;

export const FIRST_POST_JOURNEY_ID = firstPostInput.id;
export const CONTENT_STUDIO_JOURNEY_ID = contentStudioInput.id;
export const BRAND_DNA_JOURNEY_ID = brandDnaInput.id;

export const WELCOME_JOURNEY_ID = welcomeInput.id;
